// extracted by mini-css-extract-plugin
export default {"nextIcon":"next-button_nextIcon__zd7X4"};